/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteDataExportRouteSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteDataExportRouteSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteDataExportRouteSecurity = {
  option1?: DeleteDataExportRouteSecurityOption1 | undefined;
  option2?: DeleteDataExportRouteSecurityOption2 | undefined;
};

export type DeleteDataExportRouteRequest = {
  /**
   * Route ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteDataExportRouteSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteDataExportRouteSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteDataExportRouteSecurityOption1$Outbound,
  DeleteDataExportRouteSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteDataExportRouteSecurityOption1ToJSON(
  deleteDataExportRouteSecurityOption1: DeleteDataExportRouteSecurityOption1,
): string {
  return JSON.stringify(
    DeleteDataExportRouteSecurityOption1$outboundSchema.parse(
      deleteDataExportRouteSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteDataExportRouteSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteDataExportRouteSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteDataExportRouteSecurityOption2$Outbound,
  DeleteDataExportRouteSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteDataExportRouteSecurityOption2ToJSON(
  deleteDataExportRouteSecurityOption2: DeleteDataExportRouteSecurityOption2,
): string {
  return JSON.stringify(
    DeleteDataExportRouteSecurityOption2$outboundSchema.parse(
      deleteDataExportRouteSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteDataExportRouteSecurity$Outbound = {
  Option1?: DeleteDataExportRouteSecurityOption1$Outbound | undefined;
  Option2?: DeleteDataExportRouteSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteDataExportRouteSecurity$outboundSchema: z.ZodMiniType<
  DeleteDataExportRouteSecurity$Outbound,
  DeleteDataExportRouteSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteDataExportRouteSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteDataExportRouteSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteDataExportRouteSecurityToJSON(
  deleteDataExportRouteSecurity: DeleteDataExportRouteSecurity,
): string {
  return JSON.stringify(
    DeleteDataExportRouteSecurity$outboundSchema.parse(
      deleteDataExportRouteSecurity,
    ),
  );
}

/** @internal */
export type DeleteDataExportRouteRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteDataExportRouteRequest$outboundSchema: z.ZodMiniType<
  DeleteDataExportRouteRequest$Outbound,
  DeleteDataExportRouteRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteDataExportRouteRequestToJSON(
  deleteDataExportRouteRequest: DeleteDataExportRouteRequest,
): string {
  return JSON.stringify(
    DeleteDataExportRouteRequest$outboundSchema.parse(
      deleteDataExportRouteRequest,
    ),
  );
}
